import React, { useEffect, useRef, useState } from 'react'
import { Card, Col, Row, Button, ProgressBar } from 'react-bootstrap'
import { ReactComponent as OpenTask } from "../../../../assets/images/icon_svg/infoIcon.svg";
import { ReactComponent as ComplteTask } from "../../../../assets/images/icon_svg/close_history.svg";
import { ReactComponent as Arrow } from "../../../../assets/images/icon_svg/arww_wth_crcl.svg";

const Tasks = () => {
  return (

    <>
<div className='table-wrapper table-responsive'>
<div className='open_task'> <h3><OpenTask/> Open Tasks </h3></div>
<table className='task_table table'>
  <thead>
    <tr>
      <th> </th>
      <th>Task</th>
      <th>Status</th>
      <th>Priority</th>
      <th>Assigned to</th>
      <th>Due Date</th>
      <th>Created By</th>
      <th>Created on</th>
    </tr>
  </thead>
  <tbody>
      <tr>
        <td> <Arrow/> </td>
        <td>Request missing documentation </td>
        <td><span className='blue_btn'>Open</span> </td>
        <td>Medium</td>
        <td>User 1</td>
        <td>24-01-2026</td>
        <td>User 1</td>
        <td>17:00 22-01-2026</td>
      </tr>
  </tbody>
</table>
</div>
<div className='table-wrapper table-responsive'>
<div className='complete_task'> <h3><ComplteTask/> Complete Tasks </h3></div>
<table className='task_table table'>
  <thead>
    <tr>
      <th> </th>
      <th>Task</th>
      <th>Status</th>
      <th>Priority</th>
      <th>Assigned to</th>
      <th>Due Date</th>
      <th>Created By</th>
      <th>Created on</th>
    </tr>
  </thead>
  <tbody>
      <tr>
        <td> <Arrow/> </td>
        <td>Request missing documentation </td>
        <td><span className='blue_btn'>Open</span> </td>
        <td>Medium</td>
        <td>User 1</td>
        <td>24-01-2026</td>
        <td>User 1</td>
        <td>17:00 22-01-2026</td>
      </tr>
  </tbody>
</table>
</div>
<div className='table-wrapper table-responsive'>
<div className='cancel_task'> <h3><OpenTask/> Cancel Tasks </h3></div>
<table className='task_table table'>
  <thead>
    <tr>
      <th> </th>
      <th>Task</th>
      <th>Status</th>
      <th>Priority</th>
      <th>Assigned to</th>
      <th>Due Date</th>
      <th>Created By</th>
      <th>Created on</th>
    </tr>
  </thead>
  <tbody>
      <tr>
        <td> <Arrow/> </td>
        <td>Request missing documentation </td>
        <td><span className='blue_btn'>Open</span> </td>
        <td>Medium</td>
        <td>User 1</td>
        <td>24-01-2026</td>
        <td>User 1</td>
        <td>17:00 22-01-2026</td>
      </tr>
  </tbody>
</table>
</div>
</>
  )
}

export default Tasks